export const ATHLETE_SELECT = 'ATHLETE_SELECT';

export const athleteSelect = (athlete) => ({
  type: ATHLETE_SELECT,
  payload: athlete,
});
